import React, { useState } from "react";
import Hope from "../../../static/user/img/img-icons/hope.svg";
import Happiness from "../../../static/user/img/img-icons/happiness.svg";
import Health from "../../../static/user/img/img-icons/health.svg";
import Aspiration from "../../../static/user/img/img-icons/aspiration.svg";
import { Form, Select } from "antd";
import SachLoader from "../../../commons/Loader";
import { checkAuthentication, checkValidFullName, checkValidPan, checkValidPhone, checkValidUsername, getCurrentUserDetails, inputNumberOnly, isValidPinCode, parseHtml } from "../../../utils/util";
import { connect } from "react-redux";
import { resetToast } from "../../../redux/action/common";
import { postForm, createPaymentOrder, getCountries, checkPaymentStatus, getStates, getCities, getPin } from "../../../redux/action/user/contribute";
import { useEffect } from "react";
import { getContributeDataAPI } from "../../../redux/action/common-action";
import { SANDBOX_URL } from "../../../redux/constants";
import { useNavigate, useSearchParams } from "react-router-dom";
import { UserRoutes } from "../../../routes";
import Modal from "react-bootstrap/Modal";

const Contribute = ({ isLoading, contributeData, postForm, contributeJsonData, getContributeDataAPI, createPaymentOrder, getCountries, countries, createPaymentData, paymentStatus, checkPaymentStatus, getStates, states, getCities, cities, getPin, pinData }) => {
  const tabs = {
    1: "NGO",
    2: "VOLUNTEERS",
    3: "INTERNS",
  };
  const { Option } = Select;
  let navigate = useNavigate();
  const checkUser = checkAuthentication();
  const authUser = checkUser ? getCurrentUserDetails() : "";
  const [contributeSubmitted, setcontributeSubmitted] = useState(false);
  const [selectedTab, setSelectedTab] = useState("1");
  const [isFormValid, setValidForm] = useState(false);
  const [showError, setShowError] = useState("");
  const [formValues, setFormValues] = useState([]);
  const [donationAmount, setDonationAmount] = useState("0");
  const [selectedCountryId, setSelectCountryId] = useState(0);
  const [selectedStateId, setSelectStateId] = useState(0);
  const [selectedCityId, setSelectCityId] = useState(0);

  const [queryParameters] = useSearchParams();

  useEffect(() => {
    const orderId = queryParameters.get("order_id");
    if (orderId) {
      checkPaymentStatus({ orderId, contributeOrEvent: "CONTRIBUTE" });
      setcontributeSubmitted(true);
    } else {
      setcontributeSubmitted(false);
      initializeRazorpay();
      getContributeDataAPI();
      // getCountries();
    }
  }, []);

  // useEffect(() => {
  //   const orderId = queryParameters.get("order_id");
  //   let timeout;
  //   if (orderId && paymentStatus?.paymentStatus === "ACTIVE") {
  //     timeout = setTimeout(() => {
  //       checkPaymentStatus({ orderId, contributeOrEvent: 'CONTRIBUTE' });
  //       setcontributeSubmitted(true);
  //     }, 1000);
  //   }
  //   if (timeout) {
  //     // clearTimeout(timeout)
  //   }
  // }, [paymentStatus]);

  useEffect(() => {
    if (pinData?.city_name) {
      setFormValues({ ...formValues, state: pinData.state_name, city: pinData.city_name, country: pinData?.country });
    }
  }, [pinData]);

  useEffect(() => {
    const getData = setTimeout(() => {
      if (isValidPinCode(formValues.pinCode)) {
        getPin(formValues.pinCode);
      }
    }, 1000);

    return () => clearTimeout(getData);
  }, [formValues.pinCode]);
  useEffect(() => {
    if (selectedCountryId) {
      getStates(selectedCountryId);
    }
  }, [selectedCountryId]);

  useEffect(() => {
    if (selectedStateId) {
      getCities(selectedStateId);
    }
  }, [selectedStateId]);
  useEffect(() => {
    if (contributeData) {
      setFormValues({
        firstName: "",
        lastName: "",
        email: "",
        address: "",
        pinCode: "",
        state: "",
        city: "",
        country: "",
        phoneNumber: "",
        panCard: "",
        description: "",
      });
    }
  }, [contributeData, contributeJsonData, createPaymentData]);

  useEffect(() => {
    if (createPaymentData?.paymentSessionId) {
      startPaymentProcess(createPaymentData);
    }
  }, [createPaymentData]);

  useEffect(() => {
    if (countries) {
    }
  }, [countries]);
  const initializeRazorpay = async () => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = SANDBOX_URL;
      script.eval = true;

      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  };
  const startPaymentProcess = async (data) => {
    const cf = new Cashfree(data?.paymentSessionId);
    cf.redirect();
  };
  const onInputChange = (event) => {
    if (showError) {
      setShowError("");
    }
    const copyForm = Object.assign({}, formValues);
    copyForm[event.target.id] = event.target.value;
    if (event.target.id === "firstName" && event.target.value !== "" && checkValidFullName(event.target.value)) {
      copyForm["isValidName"] = true;
    } else if (event.target.id === "firstName" && event.target.value !== "" && !checkValidFullName(event.target.value)) {
      copyForm["isValidName"] = false;
    }
    if (event.target.id === "lastName" && event.target.value !== "" && checkValidFullName(event.target.value)) {
      copyForm["isValidlastName"] = true;
    } else if (event.target.id === "lastName" && event.target.value !== "" && !checkValidFullName(event.target.value)) {
      copyForm["isValidlastName"] = false;
    }
    if (event.target.id === "email" && event.target.value !== "" && checkValidUsername(event.target.value)) {
      copyForm["isValidEmail"] = true;
    } else if (event.target.id === "email" && event.target.value !== "" && !checkValidUsername(event.target.value)) {
      copyForm["isValidEmail"] = false;
    }

    if (event.target.id === "phoneNumber" && event.target.value !== "" && checkValidPhone(event.target.value)) {
      copyForm["isValidPhone"] = true;
    } else if (event.target.id === "phoneNumber" && event.target.value !== "" && !checkValidPhone(event.target.value)) {
      copyForm["isValidPhone"] = false;
    }

    if (event.target.id === "pinCode" && event.target.value !== "" && isValidPinCode(event.target.value)) {
      copyForm["isValidPinCode"] = true;
    } else if (event.target.id === "pinCode" && event.target.value !== "" && !isValidPinCode(event.target.value)) {
      copyForm["isValidPinCode"] = false;
    }

    if (event.target.id === "panCard" && event.target.value !== "" && checkValidPan(event.target.value)) {
      copyForm["isValidPan"] = true;
    } else if (event.target.id === "panCard" && event.target.value !== "" && !checkValidPan(event.target.value)) {
      copyForm["isValidPan"] = false;
    }
    if (copyForm["isValidName"] && copyForm["isValidlastName"] && copyForm["isValidEmail"] && copyForm["isValidPhone"] && copyForm["isValidPan"] && copyForm["isValidPinCode"]) {
      setValidForm(true);
    } else {
      setValidForm(false);
    }
    setFormValues(copyForm);
  };

  const setErrorMsg = () => {
    if (!formValues["firstName"] || !formValues["isValidName"]) {
      setShowError("Please Enter Valid Name, Only alphabets are allowed");
    } else if (!formValues["lastName"] || !formValues["isValidlastName"]) {
      setShowError("Please Enter Valid Name, Only alphabets are allowed");
    } else if (!formValues["email"] || !formValues["isValidEmail"]) {
      setShowError("Please Enter Valid Email Address");
    } else if (!formValues["phoneNumber"] || !formValues["isValidPhone"]) {
      setShowError("Please Enter Valid Phone Number");
    } else if (!formValues["pinCode"] || !formValues["isValidPinCode"]) {
      setShowError("Please Enter Valid Pin code");
    } else if (!formValues["panCard"] || !formValues["isValidPan"]) {
      setShowError(formFieldsData && formFieldsData.validPanCardDetails);
    } else if (selectedTab === "1" && (!parseInt(donationAmount) || isNaN(donationAmount))) {
      setShowError("Please Enter donation amount");
    } else {
      return true;
    }
  };

  const onFinish = () => {
    if (!isFormValid || (selectedTab === "1" && (!parseInt(donationAmount) || isNaN(donationAmount)))) {
      setErrorMsg();
      return;
    }

    const { country, firstName, lastName, email, phoneNumber, city, state, pinCode, panCard, address, description } = formValues;

    const requestPayload = {
      contributeAmount: donationAmount,
      contributeCurrency: "INR",
      type: tabs[selectedTab],
      firstName,
      lastName,
      description,
      panCard,
      email: email,
      mobileNo: phoneNumber,
      address: address,
      city: city,
      state: state,
      pinCode: pinCode,
      country: country,
      sachUserId: authUser?.user?.sachUserId || "",
      contributeOrEvent: "CONTRIBUTE",
      returnUrl: `${window.location.href}?order_id={order_id}`,
    };
    createPaymentOrder(requestPayload);
  };

  const topSection = contributeJsonData && contributeJsonData.topSection;
  const aboutContribute = contributeJsonData && contributeJsonData.aboutContribute;
  const contributeTabs = contributeJsonData && contributeJsonData.contributeTabs;
  const formFieldsData = contributeJsonData && contributeJsonData.formData;
  const paymentContent = contributeJsonData && contributeJsonData.paymentContent;
  const tabDetails = contributeJsonData && contributeJsonData.tabDetails;
  const [details, setDetails] = useState();
  const [activeTabClone, setActiveTabClone] = useState(1);

  const handleTabClone = (data) => {
    handleBtnClick(data);
    document.querySelector(`#pills-tab-${data.key}`).click();
  };

  const handleBtnClick = (val) => {
    debugger;
    setActiveTabClone(val.key);
    console.log(val, tabs[val.key]);
    setFormValues({
      firstName: "",
      lastName: "",
      email: "",
      address: "",
      pinCode: "",
      state: "",
      city: "",
      country: "",
      phoneNumber: "",
      panCard: "",
      query: "",
    });
    if (val?.key) {
      setSelectedTab(val.key);
      const data = tabDetails.filter((f) => f.key == val.key);
      setDetails(data);
    }
  };
  if (isLoading) {
    return (
      <section>
        <SachLoader />
      </section>
    );
  }
  return (
    <>
      <section className="contribute-hero">
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-lg-12">
              <div className="sach-title">
                {topSection && parseHtml(topSection.title)}
                <p>{topSection && parseHtml(topSection.desc)}</p>

                <ul className="contri-tabClone">
                  {contributeTabs &&
                    contributeTabs.map((item, index) => (
                      <li onClick={() => handleTabClone(item)} className={`${activeTabClone == item.key ? "active" : ""}`} key={index}>
                        <span>{item && item.title}</span>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {!contributeSubmitted && (
        <>
          <div className="container">
            <div className="hhha">
              <div className="row">
                {aboutContribute &&
                  aboutContribute.map((item, index) => (
                    <div className="col-md-3 col-lg-3" key={index}>
                      <div className="hhha-item">
                        <img src={item && "https://sach-public-file.s3.ap-south-1.amazonaws.com/img-icons/" + item.imageUrl.toLowerCase()} alt="icon" />
                        <h2>{item && item.title}</h2>
                        <p>{item && parseHtml(item.desc)}</p>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>

          <div className="container mb-5 pb-0">
            <div className="row">
              <div className="col-md-10 col-lg-10 mx-auto">
                <div className="sach-admin-tabs contribute-tabs">
                  <ul className="nav nav-pills" id="pills-tab" role="tablist">
                    {contributeTabs &&
                      contributeTabs.map((item, index) => (
                        <li className="nav-item" role="presentation" key={index}>
                          <button onClick={() => handleBtnClick(item)} className={`nav-link ${item && item.key == 1 ? "active" : ""}`} id={`pills-tab-${item && item.key}`} data-bs-toggle="pill" data-bs-target={`#pills-${item && item.key}`} type="button" role="tab" aria-controls={`pills-${item && item.key}`} aria-selected="true">
                            {item && item.title}
                          </button>
                        </li>
                      ))}
                  </ul>
                  <div className="tab-content" id="pills-tabContent">
                    {/* <!-- Tab - 1 --> */}
                    <div className="tab-pane fade show active" id="pills-1" role="tabpanel" aria-labelledby="pills-tab-1">
                      <div className="row">
                        {details ? (
                          <>
                            <div className="col-md-12">
                              <div className="contiForm-title">{details && details[0] && details[0].title}</div>
                              <div className="contiForm-para">{details && details[0] && details[0].desc}</div>
                            </div>
                            {details && details[0] && details[0].donation && details[0].donation.title && (
                              <div className="col-md-6 sach-form my-4">
                                <label className="contiForm-para mb-0">
                                  {parseHtml(details[0].donation.title)}
                                  {/* <small>*</small> */}
                                </label>
                                <div className="donationField">
                                  <input type="text" className="form-control" value={donationAmount} placeholder="0.00 INR" onChange={(e) => setDonationAmount(e.target.value)} />
                                  <span>{details[0].donation.sub}</span>
                                  <span
                                    className="autoAmnt"
                                    onClick={() => {
                                      console.log("i got clicked");
                                      setDonationAmount("3000");
                                    }}
                                  >
                                    ₹3,000
                                  </span>
                                  <span className="autoAmnt" onClick={() => setDonationAmount("5000")}>
                                    ₹5,000
                                  </span>
                                  <span className="autoAmnt" onClick={() => setDonationAmount("8000")}>
                                    ₹8,000
                                  </span>
                                  <span className="autoAmnt" onClick={() => setDonationAmount("10000")}>
                                    ₹10,000
                                  </span>
                                </div>
                              </div>
                            )}
                          </>
                        ) : (
                          <>
                            <div className="col-md-12">
                              <div className="contiForm-title">{tabDetails && tabDetails[0] && tabDetails[0].title}</div>
                              <div className="contiForm-para">{tabDetails && tabDetails[0] && tabDetails[0].desc}</div>
                            </div>

                            {tabDetails && tabDetails[0] && tabDetails[0].donation && tabDetails[0].donation.title && (
                              <div className="col-md-6 sach-form my-4">
                                <label className="contiForm-para mb-0">{parseHtml(tabDetails[0].donation.title)}</label>
                                <div className="donationField">
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={donationAmount}
                                    placeholder="0.00 INR"
                                    onChange={(e) => {
                                      setDonationAmount(e.target.value);
                                    }}
                                  />
                                  <span>{tabDetails[0].donation.sub}</span>
                                  <span className="autoAmnt" onClick={() => setDonationAmount("3000")}>
                                    ₹3,000
                                  </span>
                                  <span className="autoAmnt" onClick={() => setDonationAmount("5000")}>
                                    ₹5,000
                                  </span>
                                  <span className="autoAmnt" onClick={() => setDonationAmount("8000")}>
                                    ₹8,000
                                  </span>
                                  <span className="autoAmnt" onClick={() => setDonationAmount("10000")}>
                                    ₹10,000
                                  </span>
                                </div>
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12">
                      <Form
                        labelCol={{
                          span: 8,
                        }}
                        wrapperCol={{
                          span: 16,
                        }}
                        onFinish={onFinish}
                      >
                        <div className="row">
                          <div className="col-md-12">
                            <div className="contiForm-para mb-2">{formFieldsData && formFieldsData.title}</div>
                          </div>
                          <div className="col-md-4 sach-form">
                            <label className="form-label">
                              {formFieldsData && formFieldsData.fname}
                              <small>*</small>
                            </label>
                            <input type="text" value={formValues.firstName} className="form-control" maxLength={50} id="firstName" onChange={(e) => onInputChange(e)} required />
                          </div>
                          <div className="col-md-4 sach-form">
                            <label className="form-label">
                              {formFieldsData && formFieldsData.lname}
                              <small>*</small>
                            </label>
                            <input type="text" className="form-control" value={formValues.lastName} id="lastName" maxLength={50} onChange={(e) => onInputChange(e)} required />
                          </div>
                          <div className="col-md-4 sach-form">
                            <label className="form-label">
                              {formFieldsData && formFieldsData.email}
                              <small>*</small>
                            </label>
                            <input type="email" className="form-control" value={formValues.email} id="email" onChange={(e) => onInputChange(e)} required />
                          </div>
                          <div className="col-md-4 sach-form">
                            <label className="form-label">
                              {formFieldsData && formFieldsData.address}
                              <small>*</small>
                            </label>
                            <input type="text" className="form-control" value={formValues.address} id="address" onChange={(e) => onInputChange(e)} required />
                          </div>

                          <div className="col-md-4 sach-form">
                            <label className="form-label">
                              {formFieldsData && formFieldsData.pincode}
                              <small>*</small>
                            </label>
                            <input type="text" className="form-control" minLength={5} maxLength={6} value={formValues.pinCode} id="pinCode" onKeyDown={inputNumberOnly} onChange={(e) => onInputChange(e)} required />
                          </div>
                          <div className="col-md-4 sach-form">
                            <label className="form-label">
                              {formFieldsData && formFieldsData.state}
                              <small>*</small>
                            </label>
                            <input type="text" readOnly className="form-control" value={formValues.state} id="state" onChange={(e) => onInputChange(e)} required />
                          </div>
                          <div className="col-md-4 sach-form">
                            <label className="form-label">
                              {formFieldsData && formFieldsData.city}
                              <small>*</small>
                            </label>
                            <input type="text" readOnly className="form-control" value={formValues.city} id="city" onChange={(e) => onInputChange(e)} required />
                          </div>
                          <div className="col-md-4 sach-form">
                            <label className="form-label">
                              {formFieldsData && formFieldsData.country}
                              <small>*</small>
                            </label>
                            <input type="text" className="form-control" readOnly value={formValues.country} id="country" onChange={(e) => onInputChange(e)} required />
                          </div>

                          <div className="col-md-4 sach-form">
                            <label className="form-label">
                              {formFieldsData && formFieldsData.mobile}
                              <small>*</small>
                            </label>
                            <input type="text" min={6} max={10} minLength={6} maxLength={10} pattern="[789][0-9]{9}" className="form-control" id="phoneNumber" value={formValues.phoneNumber} onKeyDown={inputNumberOnly} onChange={(e) => onInputChange(e)} required />
                          </div>
                          <div className="col-md-4 sach-form">
                            <label className="form-label">
                              {formFieldsData && formFieldsData.pan}
                              <small>*</small>
                            </label>
                            <input type="text" className="form-control text-uppercase" value={formValues.panCard} id="panCard" maxLength={10} onChange={(e) => onInputChange(e)} required />
                          </div>
                          <div className="col-md-12 sach-form">
                            <label className="form-label">
                              {formFieldsData && formFieldsData.query}
                              <small>*</small>
                            </label>
                            <textarea value={formValues.description} maxLength={200} className="form-control" id="description" rows="4" max={200} placeholder={formFieldsData && formFieldsData.queryPlaceHolder} onChange={(e) => onInputChange(e)} required></textarea>
                          </div>
                          {showError && <div className="col-12 mt-1 error-msg">{showError}</div>}
                          <div className="col-lg-12 text-center my-md-4 py-3">
                            <button className="btn btn-sach bg-sach-dark px-5">{formFieldsData && formFieldsData.cta}</button>
                          </div>
                        </div>
                      </Form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {contributeSubmitted && (
        <Modal show={true} centered size="md">
          <Modal.Body className="py-4">
            <div className="text-center mt-4">
              <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M33.2722 37.8549C32.4812 38.6459 31.0804 38.6459 30.2894 37.8549L27.0492 34.6146L24.0664 37.5974L31.7807 45.3117L47.9326 29.16L44.9477 26.1772L33.2722 37.8549Z" fill="#64C880" />
                <path
                  d="M68.6217 21.5462C68.5126 21.4432 66.2053 19.2946 63.3257 17.7415C62.992 14.4848 61.8899 11.5308 61.8363 11.3908C61.6222 10.8244 61.1751 10.3773 60.6087 10.1631C60.4686 10.1096 57.5147 9.00751 54.258 8.67381C52.7048 5.79202 50.5543 3.48496 50.4533 3.37569C50.0372 2.93287 49.4522 2.6197 48.8465 2.71237C48.6982 2.71645 45.5466 2.82768 42.4094 3.76705C39.8716 1.69904 37.0041 0.250344 36.8681 0.18847C36.3161 -0.0628233 35.6816 -0.0628233 35.1296 0.18847C34.9936 0.250204 32.1263 1.6989 29.5885 3.76705C26.4512 2.82768 23.2996 2.71645 23.1513 2.71237C22.5168 2.62378 21.9607 2.93273 21.5446 3.37569C21.4436 3.48482 19.2931 5.79202 17.7399 8.67381C14.4832 9.00751 11.5293 10.1096 11.3892 10.1631C10.8228 10.3773 10.3757 10.8244 10.1616 11.3908C10.108 11.5308 9.00592 14.4848 8.67223 17.7415C5.79044 19.2946 3.48337 21.4452 3.37411 21.5462C2.93326 21.9623 2.69026 22.5473 2.71079 23.1529C2.71487 23.3013 2.8261 26.4529 3.76546 29.5901C1.69732 32.1279 0.248622 34.9954 0.186888 35.1312C-0.062296 35.6833 -0.062296 36.3178 0.186888 36.8697C0.248622 37.0057 1.69732 39.873 3.76546 42.4108C2.8261 45.5481 2.71487 48.6998 2.71079 48.848C2.69026 49.4537 2.93326 50.0386 3.37411 50.4548C3.48323 50.5557 5.79044 52.7063 8.67223 54.2594C9.00592 57.5161 10.108 60.4701 10.1616 60.6101C10.3757 61.1766 10.8228 61.6236 11.3913 61.8378C11.5314 61.8913 14.4832 62.9934 17.7399 63.3271C19.2931 66.2069 21.4415 68.514 21.5446 68.6231C21.9586 69.0659 22.554 69.3441 23.1513 69.2884C23.2997 69.2843 26.4513 69.1731 29.5865 68.2337C32.1265 70.2998 34.9938 71.7506 35.1298 71.8123C35.4058 71.938 35.7024 71.9998 35.9991 71.9998C36.2958 71.9998 36.5924 71.938 36.8684 71.8123C37.0044 71.7506 39.8717 70.2998 42.4095 68.2337C45.5468 69.1731 48.6985 69.2843 48.8467 69.2884C49.4729 69.3399 50.0373 69.0659 50.4535 68.6231C50.5564 68.514 52.705 66.2068 54.2581 63.3271C57.5148 62.9934 60.4667 61.8913 60.6067 61.8378C61.1753 61.6236 61.6223 61.1766 61.8365 60.6101C61.89 60.4701 62.9921 57.5161 63.3258 54.2594C66.2056 52.7063 68.5127 50.5578 68.6218 50.4548C69.0646 50.0408 69.3078 49.4558 69.2871 48.848C69.283 48.6996 69.1718 45.548 68.2324 42.4108C70.3006 39.873 71.7493 37.0056 71.811 36.8697C72.0602 36.3176 72.0602 35.6831 71.811 35.1312C71.7493 34.9952 70.3006 32.1279 68.2324 29.5901C69.1718 26.4528 69.283 23.3011 69.2871 23.1529C69.3076 22.5453 69.0645 21.9603 68.6217 21.5462ZM52.406 30.6509L33.2716 49.7855C32.8595 50.1976 32.3198 50.4036 31.7803 50.4036C31.2407 50.4036 30.7008 50.1976 30.2889 49.7855L19.5919 39.0885C18.768 38.2646 18.768 36.9296 19.5919 36.1057L25.5574 30.1402C26.3813 29.3163 27.7162 29.3163 28.5402 30.1402L31.7804 33.3804L43.4559 21.7028C44.2798 20.8789 45.6148 20.8789 46.4387 21.7028L52.4063 27.6683C53.2301 28.4922 53.2295 29.8276 52.406 30.6509Z"
                  fill="#64C880"
                />
                <circle cx="35.5" cy="35.5" r="19.5" fill="#64C880" />
                <path fillRule="evenodd" clipRule="evenodd" d="M52.1772 24.8217C52.8281 25.4725 52.8281 26.5278 52.1772 27.1787L32.1772 47.1787C31.5263 47.8295 30.4711 47.8295 29.8202 47.1787L19.8202 37.1787C19.1693 36.5278 19.1693 35.4725 19.8202 34.8217C20.4711 34.1708 21.5263 34.1708 22.1772 34.8217L30.9987 43.6431L49.8202 24.8217C50.4711 24.1708 51.5263 24.1708 52.1772 24.8217Z" fill="white" />
              </svg>
            </div>
            <div class="modal-heading text-center my-4">
              <h1 className="mb-4">{paymentStatus?.paymentStatus === "SUCCESS" ? "Thanks for contribution" : "Transaction failed please try again"}</h1>

              <span className="text-sach">{paymentStatus?.paymentStatus}</span>
            </div>
            <div className="text-center my-4">
              <button
                className="btn btn-sach bg-sach-dark"
                onClick={() => {
                  setcontributeSubmitted(false);
                  navigate("/");
                }}
              >
                {paymentContent?.cta || "Go to home"}
              </button>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  const { ContributeReducer, CommonReducer } = state;
  return {
    isLoading: ContributeReducer?.isLoading,
    toastData: CommonReducer.toastData,
    toastType: CommonReducer.toastType,
    contributeJsonData: CommonReducer.contributeJsonData,
    contributeData: ContributeReducer?.contributeData,
    countries: ContributeReducer?.countries,
    states: ContributeReducer?.states,
    cities: ContributeReducer?.cities,
    pinData: ContributeReducer?.pinData,
    createPaymentData: ContributeReducer?.createPaymentData,
    paymentStatus: ContributeReducer?.paymentStatus,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    postForm: (data) => dispatch(postForm(data)),
    resetToast: () => dispatch(resetToast()),
    getContributeDataAPI: () => dispatch(getContributeDataAPI()),
    createPaymentOrder: (data) => dispatch(createPaymentOrder(data)),
    getCountries: () => dispatch(getCountries()),
    getStates: (countryId) => dispatch(getStates(countryId)),
    getCities: (stateId) => dispatch(getCities(stateId)),
    getPin: (pinCode) => dispatch(getPin(pinCode)),
    checkPaymentStatus: (data) => dispatch(checkPaymentStatus(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Contribute);
